
namespace RioERP.Shipping {

    @Serenity.Decorators.registerClass()
    export class ShippingRulesDialog extends Serenity.EntityDialog<ShippingRulesRow, any> {
        protected getFormKey() { return ShippingRulesForm.formKey; }
        protected getIdProperty() { return ShippingRulesRow.idProperty; }
        protected getLocalTextPrefix() { return ShippingRulesRow.localTextPrefix; }
        protected getService() { return ShippingRulesService.baseUrl; }
        protected getDeletePermission() { return ShippingRulesRow.deletePermission; }
        protected getInsertPermission() { return ShippingRulesRow.insertPermission; }
        protected getUpdatePermission() { return ShippingRulesRow.updatePermission; }

        protected form = new ShippingRulesForm(this.idPrefix);

    }
}